import { BASE_URL } from '@apps/config';
import { getCarByBrand } from '@apps/config/API/new-car.config';
import CarDetailScreen from '@apps/screens/CarDetail';
import { NextPage, NextPageContext } from 'next';
import { useRouter } from 'next/router';
import { NextSeo, NextSeoProps } from 'next-seo';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { data, settings, webView } = props;
  // ======================= HOOKS
  const router = useRouter();

  // ======================= VARIABLES
  const currentUrl = `${BASE_URL}${router?.asPath}`;
  const canonicalPath = currentUrl.split('?')[0].toLowerCase();
  const carTitle = data?.data?.new_car_title || '';
  const nextSeoProps: NextSeoProps = {
    defaultTitle: `${carTitle}: Features, Specs, Reviews & Pricing | Carz Automedia Malaysia`,
    description: `Discover everything you need to know about the ${carTitle}, including features, specifications, reviews, pricing, and more. Compare options and find the perfect fit for your needs with Carz Automedia Malaysia.`,
    canonical: canonicalPath,
  };

  // ======================= VIEWS
  return (
    <>
      {!webView && <NextSeo {...nextSeoProps} />}
      <CarDetailScreen webView={webView} data={data} settings={settings} />
    </>
  );
};

Page.layout = 'none';
Page.bodyScroll = 'default';

/**
 * ===========================
 * SERVER SIDE RENDERING
 * ===========================
 */
export async function getServerSideProps(ctx: NextPageContext) {
  const slug = ctx.query?.slug;
  const model = ctx.query?.model;
  let data = [];
  if (slug && model) {
    data = await getCarByBrand({
      brand: slug as string,
      newCarSlug: model as string,
    });
  }

  if (!data.data) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      data,
    },
  };
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
